<template>
<div>
  <slot></slot>
</div>
</template>

<script>
import MessageRecipientForm from '@/components/MessageRecipientForm.vue'
import Modal from '@/components/Modal.vue'


export default {
  components: {
    MessageRecipientForm,
    Modal
  },

  props: {
    scrollable: Boolean,
    footer: Boolean,
    startBottom: Boolean,
    scrollWatcher: Date,
    hideHeader: {
      type: Boolean,
      default: false
    },
    hideFilters: {
      type: Boolean,
      default: false
    },
    hideButtons: {
      type: Boolean,
      default: true
    },
    teamId: {}
  },

  data() {
    return {
      needsToScroll: true
    }
  },

  methods: {
    maybeScrollToBottom() {
      if (this.startBottom && this.needsToScroll) {
        this.scrollToBottom()
        this.needsToScroll = false
      }
    },

    scrollToBottom() {
      var panelBody = this.$refs.panelBody
      var panelBodyHeight = panelBody.scrollHeight

      panelBody.scrollTop = panelBodyHeight
    }
  },

  updated: function () {
    this.$nextTick(this.maybeScrollToBottom())
  },

  mounted: function () {
    this.$nextTick(this.maybeScrollToBottom())
  },

  watch: {
    async scrollWatcher() {
      await this.$nextTick()
      this.$nextTick(this.scrollToBottom())
    }
  }
}
</script>
